import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {  incbyamt } from './counterSlice'


const Ocount = () => {
    const dispatch = useDispatch()
    const tcolor = useSelector((state)=>state.colorslice.color )

    const count = useSelector((state)=>
        state.counter.count
    )
  return (
    <>
        <h2 style={{color: tcolor}}>
        New Comp : {count} 
        <button onClick={()=>{
            dispatch(incbyamt(10))
        }}>Increase by 10</button>
        </h2>
    </>
  )
}

export default Ocount